import React, {useContext, useMemo} from 'react';
import {useSelector} from 'react-redux';

import {mapDateFormat} from 'src/utils/mapDateFormat';

import {FormattedDate} from '@pb/kit-component-formatters';
import {LocaleContext} from '@pb/kit-context-locale';


import {
    userSearchResultAuditDataSelector,
    userSearchResultAuditResultSelector,
} from '../../slices/user-search-result-audit.slice';

type Props = {
    userId: number,
};

export const CreatedDateCell = ({userId}: Props) => {
    const {isLoading, loadingError} = useSelector(userSearchResultAuditDataSelector);
    const result = useSelector(userSearchResultAuditResultSelector);
    const {locale} = useContext(LocaleContext);

    const createdDate = useMemo(
        () => result?.data[userId]?.created.eventTime,
        [result, userId],
    );

    if (isLoading || loadingError || !createdDate) {
        return null;
    }

    return (
        <span>{FormattedDate.format({
            value: createdDate,
            format: mapDateFormat(locale.dateFormat, 'NUMERIC'),
        })}
        </span>
    );
};
